/**
 * components/legal/vop/effectiveDate.ts
 *
 * The day the general terms (VOP) take effect: one day for the terms, their
 * specification, the price list, the processing agreement and the pages that
 * restate them. Set by the owners on 27 Oct 2026; while it is null every
 * document of the set prints an open point where its date belongs.
 *
 * A customer is bound by them from the day they accept them in their account
 * (clause 21.6), whatever this date says: that acceptance is recorded by the
 * consent screen (`components/consent/`), under the version in
 * `vopVersion.ts`.
 */

import { openPoint } from "./openPoints";

/** ISO date (`YYYY-MM-DD`), or null while it is not decided. */
export const VOP_EFFECTIVE_DATE = "2026-11-01" as string | null;

/** The date as a document prints it: the day, or the open point standing in for it. */
export function vopEffectiveDate(lang: "cs" | "en"): string {
    return VOP_EFFECTIVE_DATE ?? openPoint(lang, lang === "cs" ? "datum účinnosti" : "effective date");
}

/** The date inside a sentence: "1. 11. 2026", "1 November 2026", or the open point. */
export function vopEffectiveDateInText(lang: "cs" | "en"): string {
    if (!VOP_EFFECTIVE_DATE) return vopEffectiveDate(lang);
    const [year, month, day] = VOP_EFFECTIVE_DATE.split("-").map(Number);
    if (lang === "cs") return `${day}. ${month}. ${year}`;
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    return `${day} ${months[month - 1]} ${year}`;
}
